/**
 * AuthSessionContext — reactive view over src/lib/session.ts
 * (overhaul Wave 2).
 *
 * Gives React components `useSession()` instead of raw
 * `localStorage.getItem('user_id')` reads (200+ of which predate this and
 * migrate opportunistically). Updates on same-tab sign-in/out and
 * cross-tab storage events.
 */
import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';
import { getSession, subscribeSession, type SessionIdentity } from '@/lib/session';

const AuthSessionContext = createContext<SessionIdentity>(getSession());

export function AuthSessionProvider({ children }: { children: ReactNode }) {
  const session = useSyncExternalStore(subscribeSession, getSession, getSession);
  return (
    <AuthSessionContext.Provider value={session}>
      {children}
    </AuthSessionContext.Provider>
  );
}

/** Current signed-in identity. All fields null before login resolves. */
export function useSession(): SessionIdentity {
  return useContext(AuthSessionContext);
}
